import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SastreRecommenderState } from './sastre-recommender.state';

export const selectSastreState = createFeatureSelector<SastreRecommenderState>('sastre');

export const SastreGetLayout = () => createSelector(selectSastreState, ({ layout }) => layout);
export const SastreGetSelectedProfileId = () => createSelector(selectSastreState, ({ profileId }) => profileId);
export const SastreGetSelectedProfile = () => createSelector(selectSastreState, ({ profile }) => profile);
export const SastreGetProfiles = () => createSelector(selectSastreState, ({ profiles }) => profiles);
export const SastreGetProduct = () => createSelector(selectSastreState, ({ product }) => product);
export const SastreGetData = () => createSelector(selectSastreState, ({ data }) => data);
export const SastreGetRecommendedSize = () => createSelector(
    selectSastreState,
    // No cambiar a ({ recommendation }), puede no estar definido al consultar el valor y provocar errores
    (state) => state?.recommendation?.sizeResult || null
);
export const SastreGetRecommendedSizeAvailable = () => createSelector(
    selectSastreState,
    ({ product, recommendation }) => product.status.selectedColor.sizes
        .some(size => !Number(size.backSoon) && size.visibilityValue === 'SHOW' && size.name === recommendation?.sizeResult)
);
export const SastreGetTotalSteps = () => createSelector(selectSastreState, ({ data }) => data?.steps?.length || 0);
export const SastreGetStepIndex = () => createSelector(selectSastreState, ({ step }) => step || 0);
export const SastreGetCurrentStep = () => createSelector(selectSastreState, ({ step, data }) => data?.steps?.[step]);
export const SastreAskNext = () => createSelector(selectSastreState, ({ askNext }) => askNext);
